<template>

  <v-card>
    <v-card-title>
      <v-container fluid class="pa-0">
        <v-row>
          <v-col>
            Weekly for last 3 weeks
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>

    <v-simple-table>
      <thead>
        <tr>
          <th>Recipient(s)</th>
          <th>Condition</th>
          <th># latest</th>
          <th># w -1</th>
          <th># w -2</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.emails_csv+item.condition">
          <td>{{item.emails_csv}}</td>
          <td>{{item.condition}}</td>
          <td>{{item.latest}}</td>
          <td>{{item.w_1}}</td>
          <td>{{item.w_2}}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>

</template>

<script>
export default {
  name: 'NotificationsStatsWeekly',

  data () {
    return {
      items: [],
      showErrorAlert: false,
      errorMsg: '',
      endpoint: '/a/core/notifications-by-date-weekly?xper_page=5000',
    }
  },

  methods: {
    fetchData: function () {
      this.$http.get(this.endpoint).then(resp => {
        if (resp.data.data) {
          this.items = resp.data.data
        } else {
          this.items = []
        }
      })
      .catch(errResp => {
        this.$store.commit('system/setAPIError', { method: 'GET', url: this.endpoint, description: errResp.response.data.err_description, ext_msg: errResp.response.data.external_message })
      })
    },
  },

  created: function () {
    this.fetchData()
  }
}
</script>
